import {
  ListQueryStatus,
  ListQueryStatusProps,
} from '@/common/components/list-query-status/ListQueryStatus.tsx';
import Box from '@mui/material/Box';
import { EventsTimelineSkeleton } from '@/features/events/components/events-timeline/EventsTimeline.skeleton.tsx';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay.tsx';
import { Trans } from '@lingui/react/macro';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export type EventsTimelineQueryStatusProps = Pick<
  ListQueryStatusProps,
  'status' | 'data' | 'children'
> & {
  onRefetch: () => void;
};

export const EventsTimelineQueryStatus = ({
  onRefetch,
  ...rest
}: EventsTimelineQueryStatusProps) => {
  return (
    <ListQueryStatus
      {...rest}
      pending={
        <Box maxWidth={1000}>
          <EventsTimelineSkeleton />
        </Box>
      }
      error={
        <ErrorDisplay
          title={<Trans>Failed to load events</Trans>}
          message={<Trans>Unknown error occurred during loading of events.</Trans>}
          actions={
            <Button variant="outlined" onClick={() => onRefetch()}>
              <Trans>Try again</Trans>
            </Button>
          }
        />
      }
      empty={
        <Stack height={200} alignItems="center" justifyContent="center" gap={1}>
          <Typography variant="subtitle1">
            <Trans>No events</Trans>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <Trans>There are no events for this dispenser, that match selected criteria.</Trans>
          </Typography>
        </Stack>
      }
    />
  );
};
